import { UI, HStack, VStack } from '@genial/components';
import { Color, ColorTypes, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

export interface AssetValueWithPercentageProps {
  value: string;
  percentage: number;
  iconColor: ColorTypes.Option;
  updateDate?: string;
}

export const AssetValueWithPercentage: React.FC<AssetValueWithPercentageProps> = ({
  value,
  percentage,
  iconColor,
  updateDate,
}) => {
  return (
    <VStack>
      <HStack space={Spacing['inline.nano']} alignItems="center">
        <UI.Text color="neutral.darkest">{value}</UI.Text>
        <HStack alignItems="center" justifyContent="center">
          {percentage !== 0 && (
            <UI.Icon
              name={percentage >= 0 ? 'ArrowUp' : 'ArrowDown'}
              size="xxxxxs"
              color={Color[iconColor]}
            />
          )}
          <UI.Text color={percentage === 0 ? 'neutral.black' : iconColor}>
            {Utils.Mask.Percentage(percentage)}
          </UI.Text>
        </HStack>
      </HStack>
      {updateDate && (
        <UI.Text fontSize={Typography['fontsize.xs']} color="neutral.medium">
          {updateDate}
        </UI.Text>
      )}
    </VStack>
  );
};
